var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-autocomplete", {
    attrs: {
      "item-value": "code",
      "item-text": function(item) {
        return item.code + " " + item.description
      },
      items: _vm.categories,
      label: _vm.$t("optima.category") + " Optima"
    },
    model: {
      value: _vm.contextValue,
      callback: function($$v) {
        _vm.contextValue = $$v
      },
      expression: "contextValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }